export default __webpack_public_path__ + "dbab218205b897b970921920a6f0447e.png";